import { Injectable } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import { Angulartics2Mixpanel as _Angulartics2Mixpanel } from 'angulartics2/mixpanel';

@Injectable()
export class Angulartics2Mixpanel extends _Angulartics2Mixpanel {

    private ingnoredEvents = {
        SignInSuccess: true
    };

    private eventMapping = {
        RegistrationSuccess: 'Registration'
    }

    constructor(angulartics2: Angulartics2) {
        super(angulartics2);
    }

    eventTrack(action: string, properties: any): void {
        if (this.ingnoredEvents[action]) {
            return;
        }

        if (this.eventMapping[action]) {
            properties = Object.assign({}, properties);
            if (properties.event === action) {
                properties.event = this.eventMapping[action];
            }
            action = this.eventMapping[action];
        }

        super.eventTrack(action, properties);
    }

    setUsername(userId: string) {
        super.setUsername(userId && userId.toLowerCase());
    }

    setUserProperties(properties: any): void {
        if ('email' in properties) {
            (<any>window).mixpanel.reset();
            properties.email = properties.email && properties.email.toLowerCase();
        }
        const props = Object.assign({}, properties);
        const superProperties = {
            'email': '$email',
            'firstName': '$first_name',
            'lastName': '$last_name',
            'productInterestTemp': 'Product Interest',
            'country': 'Selected Country',
            'phone': '$phone',
            'unsubscribed': '$unsubscribed',
            'hasTenant': 'Has Tenant',
            'isTest': 'IsTest'
        };
        for (const oldKey of Object.keys(superProperties)) {
            if (oldKey in props) {
                const newKey = superProperties[oldKey];
                props[newKey] = props[oldKey];
                delete props[oldKey];
            }
        }
        super.setUserProperties(props);
    }
}